import React from "react";

const Dashboard = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh", // 100% of the viewport height
        backgroundColor: "#f0f0f0", // set your desired background color
      }}
    >
      <img
           src="assets/Images/Logo.svg"
        alt="Unicon Logo"
        style={{ marginBottom: "25px", maxWidth: "200px" }} // Adjust the image styling
      />
      <h1
        style={{
          textAlign: "center",
          fontWeight: "bold",
          color: "var(--color-secondary)", // set your desired text color
        }}
      >
        Welcome to Unicon
      </h1>
    </div>
  );
};

export default Dashboard;
